<section
  class="bg-elevated border-default flex w-64 flex-col gap-2 rounded-md border p-3 shadow-md"
  [attr.aria-label]="'features.geographic_area.editor.title_drawing' | translate">
  <header class="flex items-center gap-1.5">
    <i [class]="ICONS.polygon" class="text-accent-main text-base"></i>
    <h4 class="text-text-primary truncate text-[13px] font-semibold">
      @if (session.label()) {
        {{ 'common.editing_name' | translate: { name: session.label() } }}
      } @else {
        {{ 'features.geographic_area.editor.title_drawing' | translate }}
      }
    </h4>
  </header>

  <p class="text-text-secondary text-xs leading-snug">
    @if (session.mode() === 'drawing') {
      {{ 'features.geographic_area.editor.hint_drawing' | translate }}
    } @else {
      {{ 'features.geographic_area.editor.hint_adjusting' | translate }}
    }
  </p>

  @if (session.notice() === 'min-vertices') {
    <p class="flex items-start gap-1.5 text-xs text-orange-600 dark:text-orange-400">
      <i [class]="ICONS.warning" class="mt-px"></i>
      <span>{{ 'features.geographic_area.too_few_vertices' | translate }}</span>
    </p>
  } @else if (problem() === 'self-intersecting') {
    <p class="flex items-start gap-1.5 text-xs text-red-600 dark:text-red-400">
      <i [class]="ICONS.warningCircle" class="mt-px"></i>
      <span>{{ 'features.geographic_area.self_intersecting' | translate }}</span>
    </p>
  } @else if (problem() === 'too-few-vertices') {
    <p class="flex items-start gap-1.5 text-xs text-red-600 dark:text-red-400">
      <i [class]="ICONS.warningCircle" class="mt-px"></i>
      <span>{{ 'features.geographic_area.too_few_vertices' | translate }}</span>
    </p>
  } @else if (hasGeometry()) {
    <p class="text-text-tertiary font-mono text-xs">
      {{
        'features.geographic_area.editor.readout'
          | translate: { vertices: vertexCount(), area: areaKm2() }
      }}
    </p>
  } @else if (pendingVertices() > 0) {
    <!-- Counts the ring being placed, so a disabled Done has a visible reason. -->
    <p class="text-text-tertiary font-mono text-xs">
      {{
        'features.geographic_area.editor.pending_readout'
          | translate: { vertices: pendingVertices() }
      }}
    </p>
  }

  <div class="flex items-center justify-between gap-2">
    <button
      type="button"
      class="btn-transparent px-2 py-1 text-xs"
      [disabled]="!hasGeometry()"
      [class.btn-disabled]="!hasGeometry()"
      (click)="onClear()">
      <i [class]="ICONS.eraser" class="mr-1"></i>
      {{ 'common.clear' | translate }}
    </button>

    <div class="flex items-center gap-2">
      <button type="button" class="btn-cancel px-2.5 py-1 text-xs" (click)="onDiscard()">
        {{ 'features.geographic_area.editor.discard' | translate }}
      </button>
      <button
        type="button"
        class="btn-primary px-2.5 py-1 text-xs"
        [disabled]="!canCommit()"
        [class.btn-disabled]="!canCommit()"
        (click)="onDone()">
        <i [class]="ICONS.check" class="mr-1"></i>
        {{ 'features.geographic_area.editor.done' | translate }}
      </button>
    </div>
  </div>
</section>
